import { DataManager } from 'utils/DataManager/dataManager';
import { DataState } from 'typings/enums';
import { IPayHistory } from 'typings/payHistory';
import { IPayHistoryDataManager } from 'typings/dataManagers';
import { featureFlagHelper } from 'singletons';
import { FeatureFlags } from 'typings/enums';

class PayHistoryDataManager extends DataManager implements IPayHistoryDataManager {
    async getPayHistory(masterAccountId: string, employeeSourceId: string): Promise<Nullable<IPayHistory>> {
        const showPayHistory = featureFlagHelper.featureFlagSettings[FeatureFlags.ShowPayHistory];
        if (!showPayHistory) {
            return Promise.reject('Show pay history feature flag is off');
        }

        const receive = () => this._getDataRequest<IPayHistory>(
            // tslint:disable-next-line:max-line-length
            `/api/accounts/${masterAccountId}/team/employees/payHistory?employeeSourceId=${encodeURIComponent(employeeSourceId)}`);
        return this.getData<IPayHistory>(receive, false);
    }

    setDataState(state: DataState): void {
        this.protectedTransitionDataState(state);
    }
}

export { PayHistoryDataManager };
export default PayHistoryDataManager;